<script lang="ts">
  import { Button, Col, Modal, ModalBody, Row } from "sveltestrap"
  import TxModal from "./TxModal.svelte"
  import { chainId, selectedAccount, web3 } from "svelte-web3"
  import { COREABI } from "../abis/core"
  import { CONFIG } from "../config"

  export let data: object;
  export let action: string;

  let isOpen = false;
  let txModalOpen = false;
  let txHash = '';
  let amount = 0;

  const toggle = () => (isOpen = !isOpen);

  const submit = () => {
    const pilgrim = new $web3.eth.Contract(COREABI, CONFIG[$chainId].CORE_ADDRESS);
    let method;
    if (action === 'refund') {
      method = pilgrim.methods.refundRoundTokens;
    } else if (action === 'unbidNft') {
      method = pilgrim.methods.unbidNft;
    } else {
      method = pilgrim.methods.unbidMetaNft;
    }

    method(data.metaNftId, Math.round(Date.now() / 1000 + 30000)).send({ from: $selectedAccount })
      .on('transactionHash', hash => {
        console.log(hash);
        txHash = hash;
        isOpen = false;
        txModalOpen = true;
      })
  }
</script>


<Button class="button-fill pf-table-withdraw" on:click={toggle}>
  Withdraw Fund
</Button>
<Modal class="pil-modal" isOpen={isOpen} {toggle}>
  <ModalBody class="pil-modal-body">
    <Row>
      <Col class="modal-title">
        Withdraw the fund
      </Col>
      <Col class="col-auto">
        <img class="icon-large" src="/icons/close.svg" alt="placeholder" on:click={toggle}/>
      </Col>
    </Row>
    <Row>
      <Col class="modal-sub-title">
        {#if action === 'refund'}
          Because the NFT is sold, you are able to refund your round tokens.
        {:else}
          Because your offer has been expired, you are able to retract the withholding fund from the offer.
        {/if}
      </Col>
    </Row>
<!--    <Row>-->
<!--      <Col class="modal-sub-title">-->
<!--        You will retract-->
<!--      </Col>-->
<!--    </Row>-->
<!--    <Row>-->
<!--      <Col class="modal-amount-value">-->
<!--        2,100.00 <span class="modal-amount-unit">PIL</span>-->
<!--      </Col>-->
<!--    </Row>-->
    <Row class="justify-content-center">
      <Col class="col-auto">
        <Button class="withdraw-button" on:click={submit}>
          Withdraw Fund
        </Button>
      </Col>
    </Row>
  </ModalBody>
</Modal>
<TxModal isOpen={txModalOpen} msg="Fund withdrawal initiated" txHash={txHash}/>
